import React, { useState } from 'react';
import SubjectDropdown from '../helperComponent/SubjectDropdown';

const AddClassForm = ({ addClass }) => {
  const [title, setTitle] = useState('');
  const [classUrl, setClassUrl] = useState('');
  const [date, setDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [sub, setSub] = useState('');

  const submitHandler = (e) => {
    e.preventDefault();
    addClass({ title, classUrl, date, startTime, endTime, sub });
  };

  return (
    <form onSubmit={(e) => submitHandler(e)} className='class-form'>
      <div className='form-control'>
        <label htmlFor='title'>Title</label>
        <input
          type='text'
          value={title}
          required
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>
      <div className='form-control'>
        <label htmlFor='subject'>Subject</label>
        <SubjectDropdown setSub={setSub} />
      </div>
      <div className='form-control'>
        <label htmlFor='url'>URL</label>
        <input
          type='url'
          value={classUrl}
          required
          onChange={(e) => setClassUrl(e.target.value)}
        />
      </div>
      <div className='form-control'>
        <label htmlFor='date'>Date</label>
        <input
          type='date'
          value={date}
          required
          onChange={(e) => setDate(e.target.value)}
        />
      </div>
      <div className='form-control'>
        <label htmlFor='startTime'>Start Time</label>
        <input
          type='time'
          value={startTime}
          required
          onChange={(e) => setStartTime(e.target.value)}
        />
      </div>
      <div className='form-control'>
        <label htmlFor='endTime'>End Time</label>
        <input
          type='time'
          value={endTime}
          required
          onChange={(e) => setEndTime(e.target.value)}
        />
      </div>
      <button type='submit' className='btn'>
        Add Class
      </button>
    </form>
  );
};

export default AddClassForm;
